import { COLORS } from '@/constants/colors';

export type ApplicationStatus = 'pending' | 'accepted' | 'rejected';

export const getStatusFromCode = (
  statusCode: string | null,
): ApplicationStatus => {
  if (!statusCode) return 'pending';

  switch (statusCode.toLowerCase()) {
    case 'accepted':
    case 'confirmed':
      return 'accepted';
    case 'rejected':
    case 'declined':
    case 'cancelled':
      return 'rejected';
    default:
      return 'pending';
  }
};

export const getStatusColor = (status: ApplicationStatus): string => {
  switch (status) {
    case 'accepted':
      return COLORS.SUCCESS;
    case 'rejected':
      return COLORS.ERROR;
    case 'pending':
    default:
      return COLORS.GRAY_500;
  }
};

export const getStatusBgColor = (
  status: ApplicationStatus,
  isDark: boolean,
): string => {
  switch (status) {
    case 'accepted':
      return 'rgba(34, 197, 94, 0.15)';
    case 'rejected':
      return 'rgba(239, 68, 68, 0.15)';
    case 'pending':
    default:
      return isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
  }
};

export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  const day = date.getDate();
  const months = [
    'stycznia',
    'lutego',
    'marca',
    'kwietnia',
    'maja',
    'czerwca',
    'lipca',
    'sierpnia',
    'września',
    'października',
    'listopada',
    'grudnia',
  ];
  return `${day} ${months[date.getMonth()]}`;
};

export const formatTime = (timeStr: string): string => {
  if (!timeStr) return '';
  return timeStr.substring(0, 5);
};

export const formatTimeAgo = (
  dateStr: string,
  t?: (key: string, fallback: string) => string,
): string => {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays === 1) {
    return t ? t('common.yesterday', 'wczoraj') : 'wczoraj';
  } else if (diffDays > 1) {
    return `${diffDays} ${t ? t('common.daysAgo', 'dni temu') : 'dni temu'}`;
  } else if (diffHours > 0) {
    return `${diffHours} ${
      t ? t('common.hoursAgo', 'godz. temu') : 'godz. temu'
    }`;
  } else if (diffMinutes > 0) {
    return `${diffMinutes} ${
      t ? t('common.minutesAgo', 'min temu') : 'min temu'
    }`;
  } else {
    return t ? t('common.justNow', 'przed chwilą') : 'przed chwilą';
  }
};
